import {
  InsuranceStatus,
  InsuranceVerificationDetailsResponse,
} from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v1/insurance_verification_adapter.pb';
import {
  InsuranceCoverageResponse,
  DentalCoverageResponse,
  ErrorDetails,
} from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';
import { IconName } from '@frontend/icons';
import { StaticVerticalStepperContent } from '@frontend/static-vertical-stepper';
import { ChipVariants } from '@frontend/design-system';
import { RelationshipEnum } from './constants';
import { BenefitLimit, TuuthFairyDentalSummaryResponse } from './tuuthfairy-types';

export interface DropdownOption {
  label: string;
  value: string;
  uniqueCombinedId?: string;
  isGuardian?: boolean;
  alternativePayerIds?: string[];
  normalizedName?: string;
}

export interface BenefitLimitOverview {
  maximum: BenefitLimitNetworkDetails;
  deductible: BenefitLimitNetworkDetails;
}

export interface InsuranceDetails {
  onderfulPayerId?: string;
  payerId: string;
  payerName: string;
  groupName?: string;
  groupNumber?: string;

  nationalProviderId: string;
  providerTaxId?: string;

  firstName: string;
  lastName: string;
  memberId: string;
  dateOfBirth: string;

  relationship: RelationshipEnum;
  subscriberId?: string;
  subscriberFirstName?: string;
  subscriberLastName?: string;
  subscriberMemberId?: string;
  subscriberDateOfBirth?: string;

  pmsId?: string;
  effectiveDate?: string;
  thirdPartyCoverageStatus?: InsuranceStatus;
  overrideCoverageStatus?: InsuranceStatus;
  coverageStatus: string;
  isAutoVerification?: boolean;
  lastVerifiedAt?: string;
  planType?: string;
  requestId?: string;
  historyData?: StaticVerticalStepperContent[];
  verificationStatus?: DentalCoverageResponse['verificationStatus'];
  isElegibleForWebsiteResp?: boolean;
  benefitLimits?: BenefitLimitOverview;
  endDate?: string;
  pmsPayerId?: string;
  shouldShowOverriddenStatus?: boolean;
  errorDetails?: ErrorDetails;
  zipCode?: string;
}

export interface BenefitLimitNetworkDetails {
  inNetwork: BenefitLimit | null;
  outOfNetwork: BenefitLimit | null;
}
export interface VerificationReportData {
  totalCount: number;
  automatedCount: number;
  manualCount: number;
  hoursSaved: number;
}

export type GetPayerDetailsType = {
  payerID: string;
  payerName: string;
};
export interface UseGetInsuranceDetailsDentalOrNonDentalResponse {
  isLoading: boolean;
  isRefetching?: boolean;
  insuranceDetails: UndefinedOrNull<InsuranceDetails>;
  thirdPartyCoverage: DentalCoverageResponse | InsuranceCoverageResponse | TuuthFairyDentalSummaryResponse | undefined;
  insuranceVerificationAPIResData: InsuranceVerificationDetailsResponse | undefined;
  hasActiveOrVerifiedInsurance: boolean;
  hasInactiveInsuranceDetailsFromPartner?: boolean;
  refetchInsuranceDetails?: () => void;
}

export type UndefinedOrNull<T> = T | null | undefined;

export type StatusInfo = {
  text: string;
  variant: ChipVariants;
  iconName: IconName;
};

export enum StatusSelectionLabel {
  AutoVerified = 'Auto-Verified',
  Error = 'Error',
  ManualVerified = 'Manual Verified',
  Unverified = 'Unverified',
  Total = 'Total',
}

export enum StatusSelection {
  Verified = 'verified',
  Unverified = 'unverified',
  Error = 'error',
}
